/**
 * Reusable skeleton loader primitives.
 * Premium White SaaS - subtle pulse, neutral grays.
 */

export const SkeletonLine = ({ width = "100%", height = "12px", className = "" }) => (
  <div
    className={`rounded-md bg-[#F2F2F2] animate-pulse ${className}`}
    style={{ width, height }}
  />
);

export const SkeletonBlock = ({ width = "100%", height = "60px", className = "" }) => (
  <div
    className={`rounded-xl bg-[#F2F2F2] animate-pulse ${className}`}
    style={{ width, height }}
  />
);

export const SkeletonCard = ({ rows = 3, className = "" }) => (
  <div className={`rounded-[20px] bg-white border border-[rgba(0,0,0,0.06)] p-5 space-y-3 ${className}`} data-testid="skeleton-card">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-xl bg-[#F2F2F2] animate-pulse" />
      <div className="flex-1 space-y-2">
        <SkeletonLine width="40%" height="14px" />
        <SkeletonLine width="70%" height="10px" />
      </div>
    </div>
    {Array.from({ length: rows }).map((_, i) => (
      <SkeletonLine key={i} width={i === rows - 1 ? "60%" : "100%"} height="10px" />
    ))}
  </div>
);

export const SkeletonList = ({ count = 3, className = "" }) => (
  <div className={`space-y-2 ${className}`} data-testid="skeleton-list">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="flex items-center gap-3 px-3 py-3 rounded-xl border border-[rgba(0,0,0,0.06)]">
        <div className="w-10 h-10 rounded-xl bg-[#F2F2F2] animate-pulse flex-shrink-0" />
        <div className="flex-1 space-y-2">
          <SkeletonLine width="60%" height="12px" />
          <SkeletonLine width="40%" height="9px" />
        </div>
        <div className="w-16 h-7 rounded-full bg-[#F2F2F2] animate-pulse flex-shrink-0" />
      </div>
    ))}
  </div>
);

export const SkeletonStatGrid = ({ count = 5 }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="skeleton-stats">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="rounded-[20px] bg-white border border-[rgba(0,0,0,0.06)] p-4 space-y-2">
        <div className="w-9 h-9 rounded-xl bg-[#F2F2F2] animate-pulse" />
        <SkeletonLine width="50%" height="22px" />
        <SkeletonLine width="70%" height="10px" />
      </div>
    ))}
  </div>
);
